import { Versions } from "@stomp/stompjs";
import style from "./OutOfStock.module.css";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import P from "components/P";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import Center from "layouts/wrapper/Center";
import CustomIcon from "components/icons/CustomIcon";
import { useEffect, useState } from "react";
import { requester, adminRequester } from "App";
import Inline from "layouts/container/Inline";
import { useNavigate } from "react-router-dom";
import AdminImage from "components/Image/AdminImage";

function OutOfStock() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [mounted, setMounted] = useState(false);

  

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (mounted) {
      adminRequester.getVariants(
        { inventory_quantity: 0, limit: 3 },
        
        (result) => setData([...result.variants])
      );
      
    }
  }, [mounted]);
  const DummyProduct = (props) => {
    const { data } = props;
    return (
      <div
        className={style.dummyWrap}
        onClick={() => navigate(`/admin/stockManagement`)}
      >
        <VerticalFlex gap={10}>
          <FlexChild>
            {/* <img
              style={{ width: "100%" }}
              src={data && data.thumbnail}
              alt={"thumbnail"}
            /> */}
            <AdminImage
              src={data && data.thumbnail}
              alt={"thumbnail"}
              style={{ width: "80%" }}
              emptyRatio={`1 / 1`}
            />
          </FlexChild>
          <FlexChild>
            <Inline>
              <P>{data?.product?.title}</P>
              <P>{data?.title}</P>
            </Inline>
          </FlexChild>
          <FlexChild>
            <P color={"var(--main-color)"}> {data.inventory_quantity || 0}개</P>
          </FlexChild>
        </VerticalFlex>
      </div>
    );
  };

  return (
    <div className={style.wrap}>
      <VerticalFlex gap={0} height="100%">
        <FlexChild height="min-content">
          <div className={style.label}>
            <HorizontalFlex padding={"0 10px"}>
              <FlexChild>
                <HorizontalFlex gap={5}>
                  <FlexChild width={50}>
                    <Center width={"100%"}>
                      <CustomIcon name={"outOfStock"} width={20} />
                    </Center>
                  </FlexChild>
                  <FlexChild>
                    <Center width={"100%"} textAlign={"left"}>
                      <P color={"white"} weight={"bold"}>
                        품절 상품
                      </P>
                    </Center>
                  </FlexChild>
                </HorizontalFlex>
              </FlexChild>
              <FlexChild width={"max-content"}>
                <VerticalFlex>
                  <FlexChild>
                    <P
                      cursor
                      onClick={() => navigate(`/admin/stockManagement`)}
                      size={"14pt"}
                      color={"white"}
                    >
                      {">"}
                    </P>
                  </FlexChild>
                </VerticalFlex>
              </FlexChild>
            </HorizontalFlex>
          </div>
        </FlexChild>
        <FlexChild>
          <div className={style.productArea} style={{ height: "100%" }}>
            <HorizontalFlex gap={10}>
              {data &&
                data.map((datum, index) => (
                  <FlexChild key={index}>
                    <FlexChild>
                      <DummyProduct
                        type={"취소"}
                        data={datum}
                        size={data.length}
                      />
                    </FlexChild>
                    {index !== data.length - 1 && (
                      <FlexChild width={"max-content"}>
                        <div className={style.line} />
                      </FlexChild>
                    )}
                  </FlexChild>
                ))}
              {data &&
                data.length > 0 &&
                data.length < 3 &&
                [0, 1, 2]
                  .filter((f) => f >= data.length)
                  .map((index) => <FlexChild key={`dummy_${index}`} />)}
              {data.length === 0 && (
                <HorizontalFlex justifyContent="center">
                  <P textAlign="center">없음</P>
                </HorizontalFlex>
              )}
            </HorizontalFlex>
          </div>
        </FlexChild>
      </VerticalFlex>
    </div>
  );
}

export default OutOfStock;
